/**
 * Resolve the unified import wizard's navigation targets for a given
 * `reportType`. The wizard pages (`goods-import-intro-page`,
 * `goods-import-type-page`, `goods-import-configure-page`) are shared between
 * purchased and sold goods, so they must not hardcode one module's routes —
 * they look the targets up here off the `reportType` carried on the
 * `ImportLayout` context. The `goodsType` is also the path segment posted to
 * the `/process-v2/<goodsType>/` endpoint.
 */
import { purchasedGoodsRoutes } from '@app/purchased-goods/purchased-goods-routes';
import { soldGoodsRoutes } from '@app/sold-goods/sold-goods-routes';
import { ImportGoodsType } from '@shared/api/hooks/ccf/mixed-imports';
import { OperationReportTypeEnum } from '@shared/api/types';

export interface GoodsImportRoutes {
  landing: string;
  types: string;
  organise: string;
  importsList: string;
  excludedItems: string;
  goodsType: ImportGoodsType;
}

export function getGoodsImportRoutes(
  reportType: OperationReportTypeEnum
): GoodsImportRoutes {
  if (reportType === OperationReportTypeEnum.sales) {
    return {
      landing: soldGoodsRoutes.SOLD_GOODS_IMPORT,
      types: soldGoodsRoutes.SOLD_GOODS_IMPORT_TYPES,
      organise: soldGoodsRoutes.SOLD_GOODS_IMPORT_ORGANISE,
      importsList: soldGoodsRoutes.SOLD_GOODS_IMPORTS_LIST,
      excludedItems: soldGoodsRoutes.SOLD_EXCLUDED_ITEMS,
      goodsType: 'sold-goods',
    };
  }

  return {
    landing: purchasedGoodsRoutes.PURCHASED_GOODS_IMPORT,
    types: purchasedGoodsRoutes.PURCHASED_GOODS_IMPORT_TYPES,
    organise: purchasedGoodsRoutes.PURCHASED_GOODS_IMPORT_ORGANISE,
    importsList: purchasedGoodsRoutes.PURCHASED_GOODS_IMPORTS_LIST,
    excludedItems: purchasedGoodsRoutes.PURCHASED_EXCLUDED_ITEMS,
    goodsType: 'purchased-goods',
  };
}
